import React, { useState } from "react";
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import moment from "moment";

//Components
import { RadioGroup } from '@gpstrackit/gtc-react-controls';
import { Box } from "@mui/material";
import { Input } from "Components";
import Loading from './Loading';

//Actions
import { reset, editField } from '../redux/slice'

const OdometerEngineHours = (props) => {
    const { formData, setFormData } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();


    //Redux States
    const { loadingConfig, newOdometer, newEngineOdometer, unitDetail } = useSelector(state => state.troubleshootDeviceRedux);
    const user = useSelector((state) => state.securityRedux.user);

    //Options for RadioGroup
    const options = [
        { label: messages['troubleshootDevice_yes'], value: "1" },
        { label: messages['troubleshootDevice_no'], value: "2" }
    ];

    const handlerOdometer = (value) => {
        dispatch(editField({ field: "newOdometer", value }))
        dispatch(reset({ updateUnit: null }))
    }

    const handlerEngineHours = (value) => {
        dispatch(editField({ field: "newEngineOdometer", value }))
        dispatch(reset({ updateUnit: null }))
    }

    return (
        <div>
            {
                unitDetail?.deviceModel?.odometerEnable && <div className="troubleshoot-device-main">
                    {
                        loadingConfig ? (
                            <Loading title={messages["troubleshootDevice_checkingOdometer"]} />
                        ) : (
                            <>
                                <div>
                                    <label htmlFor="odometer" style={{ marginRight: 5 }}>{messages['troubleshootDevice_odometer']} ({user?.isKph ? "km" : "mi"}):</label>
                                    <span id="odometer" className="odometer">{formData?.totalOdometer}</span>
                                </div>
                                <div style={{ marginTop: 10 }}>
                                    <span>{messages['troubleshootDevice_isTheOdometerReadingCorrect']}</span>
                                    <div>
                                        <RadioGroup
                                            onChange={(e) => handlerOdometer(e)}
                                            value={newOdometer}
                                            list={options}
                                            labelDir="row"
                                        />
                                    </div>
                                    {
                                        newOdometer === "2" && (
                                            <div>
                                                <div className="odometer-engine-horus-input">
                                                    <label htmlFor="dash-reading">{messages['troubleshootDevice_dashReading']} ({user?.isKph ? "km" : "mi"}):</label>
                                                    <Input
                                                        id="new-odometer-value"
                                                        type="number"
                                                        decimalPlaces={2}
                                                        placeholder={`${messages['troubleshootDevice_dashReading']} (${user?.isKph ? "km" : "mi"})`}
                                                        maxLength={12}
                                                        max={100000000}
                                                        preventOnChange
                                                        onChange={(value) => {
                                                            dispatch(reset({ updateUnit: null }))
                                                            setFormData({
                                                                ...formData,
                                                                dashOdometer: value,
                                                                offsetEcuEngineOdometer: Number(value - formData.ecuEngineOdometer).toFixed(2),
                                                                offsetEngineOdometer: Number(value - formData.engineOdometer).toFixed(2),
                                                                offsetEngineOdometerUpdatedOn: !formData.useEcuOdometer ? moment().utc().format() : formData.offsetEcuEngineOdometerUpdatedOn || null,
                                                                offsetEcuEngineOdometerUpdatedOn: formData.useEcuOdometer ? moment().utc().format() : formData.offsetEcuEngineOdometerUpdatedOn || null,
                                                            })
                                                        }}
                                                        value={formData?.dashOdometer}
                                                    />
                                                </div>
                                                {
                                                    formData.useEcuOdometer &&
                                                    <Box mt={0.5}>
                                                        <span className="subtitle">
                                                            {`ECU: ${formData.useEcuOdometer
                                                                ? `${formData.ecuEngineOdometer || 0} (+ ${formData.offsetEcuEngineOdometer || 0})`
                                                                : `${formData.engineOdometer || 0} (+ ${formData.offsetEngineOdometer || 0})
                                                        ${messages['troubleshootDevice_offset']}: ${formData?.useEcuOdometer && formData.offsetEcuEngineOdometer || formData.offsetEngineOdometer}`}`}
                                                        </span>
                                                    </Box>
                                                }
                                                <Box mt={0.5}>
                                                    <span className="subtitle">
                                                        {formData?.offsetEngineOdometerUpdatedOnLabel &&
                                                            messages["unit_settings_last_updated"]
                                                            + " " +
                                                            formData?.offsetEngineOdometerUpdatedOnLabel}
                                                    </span>
                                                </Box>
                                            </div>

                                        )
                                    }
                                </div>
                            </>
                        )
                    }

                </div>
            }
            {
                unitDetail?.deviceModel?.hoursEnable && <div className="troubleshoot-device-main" style={{ marginTop: 10 }}>
                    {
                        loadingConfig ? (
                            <Loading title={messages['troubleshootDevice_CheckingEngineHours']} />
                        ) : (
                            <>
                                <div style={{ marginTop: 10 }}>
                                    <label htmlFor="odometer" style={{ marginRight: 5 }}>{messages['troubleshootDevice_engineHours']} (hrs):</label>
                                    <span id="odometer" className="odometer">{formData?.totalEngineHours}</span>
                                </div>
                                <div style={{ marginTop: 10 }}>
                                    <span>{messages['troubleshootDevice_IsThisEngineHoursReadingCorrect']}</span>
                                    <div>
                                        <RadioGroup
                                            onChange={(e) => handlerEngineHours(e)}
                                            value={newEngineOdometer}
                                            list={options}
                                            labelDir="row"
                                        />
                                    </div>
                                    {
                                        newEngineOdometer === "2" && (
                                            <div>
                                                <div className="odometer-engine-horus-input">
                                                    <label htmlFor="engine-hours-actual">Actual (hrs)</label>
                                                    <Input
                                                        id="new-odometer-value"
                                                        type="number"
                                                        decimalPlaces={2}
                                                        placeholder="Actual (hrs)"
                                                        maxLength={12}
                                                        max={100000000}
                                                        preventOnChange
                                                        onChange={(value) => {
                                                            dispatch(reset({ updateUnit: null }))
                                                            setFormData({
                                                                ...formData,
                                                                dashEngineHours: value,
                                                                offsetEcuEngineHours: Number(value - formData.ecuEngineHours).toFixed(2),
                                                                offsetEngineHours: Number(value - formData.engineHours).toFixed(2),
                                                                offsetEngineHoursUpdatedOn: !formData.useEcuEngineHours ? moment().utc().format() : formData.offsetEngineHoursUpdatedOn || null,
                                                                offsetEcuEngineHoursUpdatedOn: formData.useEcuEngineHours ? moment().utc().format() : formData.offsetEcuEngineHoursUpdatedOn || null,
                                                            })
                                                        }}
                                                        value={formData?.dashEngineHours}
                                                    />
                                                </div>
                                                {
                                                    formData?.useEcuEngineHours != 0 &&
                                                    <Box mt={0.5}>
                                                        <span className="subtitle">
                                                            {`ECU: 
                                                                ${formData?.useEcuEngineHours
                                                                    ? `${formData?.ecuEngineHours || 0} (+ ${formData?.offsetEcuEngineHours || 0
                                                                    })`
                                                                    : `${formData?.engineHours || 0} (+ ${formData?.offsetEngineHours || 0
                                                                    })`
                                                                }
                                                    `}
                                                        </span>
                                                    </Box>
                                                }
                                            </div>
                                        )
                                    }
                                </div>
                            </>
                        )
                    }
                </div>
            }
            {
                (newOdometer === "2" || newEngineOdometer === "2") ? (
                    <div style={{ display: 'flex', textAlign: 'center', marginTop: 10 }}>
                        <p>
                            {
                                unitDetail?.deviceModel?.odometerEnable && unitDetail?.deviceModel?.hoursEnable 
                                ? messages['troubleshootDevice_clickNextToContinue'] 
                                : unitDetail?.deviceModel?.odometerEnable && !unitDetail?.deviceModel?.hoursEnable 
                                ? messages['troubleshootDevice_clickNextToContinueOnlyOdometer'] : !unitDetail?.deviceModel?.odometerEnable && unitDetail?.deviceModel?.hoursEnable ? messages['troubleshootDevice_clickNextToContinueOnlyEngineHours'] : ""}
                        </p>
                    </div>
                ) : <></>
            }
        </div>
    )
}

export default OdometerEngineHours